export default __webpack_public_path__ + "static/roadmap-desktop_es_v2-e815ae1b50f20c44c37f86fa11fa555a.png";